import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://zwgpmobugscpdcavajbu.supabase.co'; // ← cambia con il tuo
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp3Z3Btb2J1Z3NjcGRjYXZhamJ1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTAzMzk4MjEsImV4cCI6MjA2NTkxNTgyMX0.1ZqIcOByAuWTJFFd0VXO5KE_8imZcAwCqtPMoAkqFPI';                // ← chiave pubblica ANON

export const supabase = createClient(supabaseUrl, supabaseKey);
